import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { IAccount, INewAccount } from '../../utils/interfaces/interfaces';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux';
import { notify } from '../../notifications/notification';
import { capitalizeFirstLetter, formatDate } from '../../utils/strings';
import {
  updateAccount,
  updateAccountAsAdmin,
  updateSecondaryAccount
} from '../../network/user';
import { AxiosResponse } from 'axios';
import {
  validatePrimaryAccount,
  validateSecondaryAccount
} from '../../utils/validators';
import { getInstitution } from '../../network/institution';
import CDropdown from '../dropdown/dropdown';
import { AllTypes, TypeDropdown, Types, types_types } from '../../types/users';
import styles from '../../pages/monitorization/monitorization.module.scss';
import { API } from '../../api';
import { TagTypes } from '../../api/apiBase.types';

interface IAAccount {
  callback: () => void;
  selectedAccount?: IAccount;
  isAdmin?: boolean;
  addAccount: (form: INewAccount) => Promise<AxiosResponse<any>>;
  isPrincipal?: boolean;
}

const initialState: INewAccount = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  institutionName: '',
  institutionPrivate: false,
  publicAcquisitions: false,
  contractExpirationDate: new Date(),
  type: Types.All
};

const AddAccount = (props: IAAccount) => {
  const [form, updateForm] = useState(initialState);
  const id = useAppSelector((state: RootState) => state.session.id) as string;
  const user = useAppSelector((state: RootState) => state.session.user);
  const [type, setType] = useState<TypeDropdown>(AllTypes[0]);
  const dispatch = useAppDispatch();

  const handleInstitutionPrivateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value, name } = event.target;
    console.log(value);
    updateForm(form => ({ ...form, [name]: !form.institutionPrivate }));
  };

  const handlePublicAcquisitionsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value, name } = event.target;
    if (value == undefined) return;
    console.log(value);
    console.log(form);
    console.log({ ...form, [name]: !form.publicAcquisitions });
    updateForm(form => ({ ...form, [name]: !form.publicAcquisitions }));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    updateForm(form => ({ ...form, [name]: value }));
  };

  const formatPhoneNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;

    if (value.length > 10) {
      updateForm(f => ({ ...f, [name]: f.phone }));
    } else updateForm(f => ({ ...f, [name]: value }));
  };

  const handleType = (item: any) => {
    setType(item);
    updateForm(form => ({ ...form, type: item.key }));
  };

  const handleSubmit = (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();

    /* if validation fails stop propagation */
    if (props.isAdmin && !validatePrimaryAccount(form)) return;
    if (!props.isAdmin && !validateSecondaryAccount(form)) return;

    /* add principal account as admin */
    if (!props.selectedAccount?.id && props.isAdmin) {
      console.log('QWE');
      props
        .addAccount({
          ...form,
          firstName: capitalizeFirstLetter(form.firstName),
          lastName: capitalizeFirstLetter(form.lastName),
          type: type.key,
          institutionPrivate: form.institutionPrivate ? true : false
        })
        .then(() => props.callback());
      return;
    }

    /* add secondary account as principal */
    if (!props.selectedAccount?.id && !props.isAdmin) {
      console.log('QWE1');
      const { institutionPrivate, institutionName, ...user } = form;
      console.log(user);

      props
        .addAccount({
          ...user,
          principalUserId: id,
          firstName: capitalizeFirstLetter(form.firstName),
          lastName: capitalizeFirstLetter(form.lastName),
          type: form.type,
          publicAcquisitions: form.publicAcquisitions
        })
        .then(() => {
          props.callback();
        });
      return;
    }

    /* update principal account as admin */
    if (props.selectedAccount?.id && props.isAdmin) {
      console.log('QWE2');
      console.log(form);
      updateAccountAsAdmin({
        ...props.selectedAccount,
        ...form,
        firstName: capitalizeFirstLetter(form.firstName),
        lastName: capitalizeFirstLetter(form.lastName),
        institutionPrivate: form.institutionPrivate,
        publicAcquisitions: form.publicAcquisitions
      }).then(() => {
        props.callback();
        notify('Contul a fost modificat cu succes.', 'success');
      });
      return;
    }

    /* update principal account as principal */
    if (props.selectedAccount?.id && props.isPrincipal) {
      console.log('QWE3');
      updateAccount({
        ...user,
        firstName: capitalizeFirstLetter(form.firstName),
        lastName: capitalizeFirstLetter(form.lastName),
        email: form.email,
        phone: form.phone,
        type: form.type
      }).then(() => {
        props.callback();
        notify('Contul a fost modificat cu succes.', 'success');
        dispatch(API.util.invalidateTags([TagTypes.CurrentUser]));
      });
      return;
    }

    /* update secondary account as admin */
    if (props.selectedAccount?.id && !props.isAdmin) {
      console.log('QWE4');
      console.log(form.publicAcquisitions);
      updateSecondaryAccount({
        id: props.selectedAccount?.id,
        firstName: capitalizeFirstLetter(form.firstName),
        lastName: capitalizeFirstLetter(form.lastName),
        email: form.email,
        phone: form.phone,
        type: form.type,
        publicAcquisitions: form.publicAcquisitions
      }).then(() => {
        props.callback();
        notify('Contul a fost modificat cu succes.', 'success');
      });
      return;
    }
  };

  const handleDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    new Date(value) &&
      updateForm(form => ({
        ...form,
        contractExpirationDate: new Date(value)
      }));
  };

  const fetchData = async (institutionId: number) =>
    await getInstitution(institutionId);

  useEffect(() => {
    if (props.selectedAccount?.id) {
      const {
        firstName,
        lastName,
        email,
        phone,
        contractExpirationDate,
        institutionId,
        type,
        publicAcquisitions
      } = props.selectedAccount;

      const currentType = AllTypes.find(t => t.key === type);
      if (currentType) {
        setType(currentType);
      }

      if (institutionId) {
        fetchData(institutionId).then(({ data }) =>
          updateForm({
            firstName,
            lastName,
            email,
            phone,
            institutionName: data.name,
            institutionPrivate: data.private,
            contractExpirationDate: new Date(contractExpirationDate),
            type,
            publicAcquisitions
          })
        );
      } else {
        updateForm({
          firstName,
          lastName,
          email,
          phone,
          contractExpirationDate: new Date(contractExpirationDate),
          type
        });
      }
    } else {
      updateForm(initialState);
    }

    // eslint-disable-next-line
  }, [props.selectedAccount]);

  return (
    <form>
      <p className='body-dark bold'>
        {props.selectedAccount?.id ? 'Editare cont' : 'Adăugare cont'}
      </p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />

      {!props.isAdmin && props.selectedAccount?.role !== 'principal_user' && (
        <CDropdown
          label='Tip'
          placeholder=''
          visibleKey='name'
          currentOption={type}
          onChange={handleType}
          list={AllTypes}
          className={styles.dropdownStatuses}
          viewOnly
        />
      )}
      <CInput
        label='Nume'
        type='text'
        id='firstName'
        placeholder='Nume'
        name='firstName'
        value={form.firstName}
        onChange={handleChange}
        required
      />
      <CInput
        label='Prenume'
        type='text'
        id='lastName'
        placeholder='Prenume'
        name='lastName'
        value={form.lastName}
        onChange={handleChange}
        required
      />

      <CInput
        label='Adresa de email'
        type='text'
        id='email'
        placeholder='Adresa de email'
        name='email'
        value={form.email}
        onChange={handleChange}
        required
      />

      <CInput
        label='Număr de telefon'
        type='number'
        id='phone'
        placeholder='Număr de telefon'
        name='phone'
        value={form.phone}
        onChange={formatPhoneNumber}
        required
      />

      {!props.isAdmin && (
        <CInput
          label='Achizitii publice'
          type='checkbox'
          id='publicAcquisitions'
          name='publicAcquisitions'
          value={form.publicAcquisitions ? 'true' : 'false'}
          checked={form.publicAcquisitions}
          onChange={handlePublicAcquisitionsChange}
        />
      )}

      {props.isAdmin && (
        <CInput
          label='Numele instituției'
          type='text'
          id='institution'
          placeholder='Numele instituției'
          name='institutionName'
          value={form.institutionName}
          onChange={handleChange}
          required
        />
      )}
      {props.isAdmin && (
        <CInput
          label='Privat'
          type='checkbox'
          id='institutionPrivate'
          name='institutionPrivate'
          value={form.institutionPrivate ? 'true' : 'false'}
          checked={form.institutionPrivate}
          onChange={handleInstitutionPrivateChange}
        />
      )}

      {props.isAdmin && (
        <CInput
          label='Dată expirare contract'
          type='date'
          id='expirationDate'
          placeholder='expirare'
          name='institutionName'
          value={formatDate(form.contractExpirationDate)}
          onChange={handleDate}
          required
        />
      )}

      <Space vertical={'30px'} />
      <CButton
        label={props.selectedAccount?.id ? 'Salvează' : 'Adăugare'}
        type='submit'
        onClick={handleSubmit}
      />
    </form>
  );
};

export default AddAccount;
